export { default as HeadlineAnim } from './HeadlineAnim';